import { BaseUseCase } from "../UseCaseBase";
class AdBlockUseCase extends BaseUseCase {
    constructor(repo) {
        super();
        this.repo = repo;
    }
    async fetchResult() {
        return await this.repo.getNewUpdatesData();
    }
}
export default AdBlockUseCase;
